import { Colors, StatusColors } from '@euler/components/Colors';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { InfiniteListStatus } from '@euler/functions/useInfiniteList';
import { memo } from 'react';
import {
  ActivityIndicator,
  StyleProp,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewProps,
} from 'react-native';
import { useTheme } from 'styled-components';

export const InfiniteListFooter = memo(
  ({
    status,
    noMoreText,
    emptyText,
    textStyle,
    onRecoverFromError,
    ...props
  }: {
    status: InfiniteListStatus;
    noMoreText?: string;
    emptyText?: string;
    textStyle?: StyleProp<TextStyle>;
    onRecoverFromError?: () => void;
  } & ViewProps) => {
    const { rpx } = useResponsiveContext();
    const theme = useTheme();
    const { error, isLoading, hasMore, isRefreshing, loadedDataLength } =
      status;
    return error ? (
      <View
        css={`
          padding: ${rpx(10)}px;
        `}
        {...props}
      >
        <Text
          css={`
            text-align: center;
            font-family: ${FontFamily.NotoSans.Regular};
            font-size: ${rpx(12)}px;
            line-height: ${rpx(18)}px;
            color: ${StatusColors.Danger};
          `}
          style={textStyle}
        >
          获取数据时发生了一个错误! {'\n'}
          {__DEV__ ? error.message : ''}
        </Text>
        <TouchableOpacity onPress={onRecoverFromError}>
          <Text
            css={`
              text-align: center;
              font-family: ${FontFamily.NotoSans.Regular};
              font-size: ${rpx(12)}px;
              line-height: ${rpx(18)}px;
              color: ${theme.link};
            `}
          >
            重试
          </Text>
        </TouchableOpacity>
      </View>
    ) : !isRefreshing && isLoading && status.loadedDataLength > 0 ? (
      <ActivityIndicator
        css={`
          margin: ${rpx(8)}px;
        `}
      />
    ) : !hasMore ? (
      <View
        css={`
          padding: ${rpx(10)}px;
        `}
        {...props}
      >
        <Text
          css={`
            text-align: center;
            font-family: ${FontFamily.NotoSans.Regular};
            font-size: ${rpx(12)}px;
            line-height: ${rpx(18)}px;
            color: ${Colors.Gray3};
            padding-top: ${rpx(20)}px;
          `}
          style={textStyle}
        >
          {loadedDataLength
            ? noMoreText ?? '没有更多数据了'
            : emptyText ?? '暂无相关数据'}
        </Text>
      </View>
    ) : null;
  },
);
